import { createStore, combineReducers, applyMiddleware } from 'redux';
import { globalReducer } from './globalReducer';
import ReduxThunk from 'redux-thunk';

const rootReducer = combineReducers({
	global: globalReducer,
});

export const store = createStore(rootReducer, applyMiddleware(ReduxThunk));
